import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Button, Spinner,Form } from 'react-bootstrap';
import { json, useNavigate, useSearchParams } from 'react-router-dom';
import { postDataUser } from '../ApiServices/ApiService';
import clock from '../assets/icons/clock.png';
import Logo from './../assets/icons/logo2.jpeg';
import UserNav from '../Users/UserNav';

const CodeInterviewPage = () => {
  const [searchParams] = useSearchParams();
  const testId = searchParams.get('id');
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [totalQuestions, setTotalQuestions] = useState(0);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);

  var testTime= "";
  const [timer, setTimer] = useState(null); // 3 minutes in seconds
  const [fetchedTestTimeId, setFetchedTestTimeId] = useState(null);

  const [isTimerRunning, setIsTimerRunning] = useState(true);
  const [error, setError] = useState('Loading ...');
  const [respError, setRespError] = useState('');

  const mediaRecorderRef = useRef(null);
  const mediaVideoRecorderRef = useRef(null);
  const videoRef = useRef(null);

  const startCapture = (qid,url) => {
    console.log("qid", qid)
    navigator.mediaDevices.getUserMedia({ video: true , audio: true})
      .then((stream) => {
        videoRef.current.srcObject = stream;
        videoRef.current.onloadedmetadata = () => {
          videoRef.current.muted = true;
          videoRef.current.play();
          mediaVideoRecorderRef.current = new MediaRecorder(stream);
          const chunks = [];
          mediaVideoRecorderRef.current.ondataavailable = (event) => {
            if (event.data.size > 0) {
              chunks.push(event.data);
            }
          };
  
          mediaVideoRecorderRef.current.onstop = () => {
            const blob = new Blob(chunks, { type: 'video/webm' });
            sendVideoBlobToBackend(blob,firstQuestion);
            console.log("chunks",chunks);
            console.log("video", blob);
          };
  
          mediaVideoRecorderRef.current.start();
        };
      })
      .catch((err) => {
        console.error('Error accessing the camera:', err);
      });
  };
  
  useEffect(() => {
      startCapture();
  }, []);

  const stopCapture = () => {
    mediaVideoRecorderRef.current.stop();
  
    const stream = videoRef.current.srcObject;
    if (stream) {
      const tracks = stream.getTracks();
      tracks.forEach((track) => {
        if (track.kind === "video") {
          track.stop(); // Stop video track
        } else if (track.kind === "audio") {
          track.stop(); // Stop microphone track (if used)
        }
      });
    }
  
    videoRef.current.srcObject = null;
  };

  const [firstQuestion,setFirstQuestion] = useState(null)
  const [checkQuestion, setCheckQuestion] = useState(false);
  useEffect(() => {
    if (questions.length > 0) {
        setFirstQuestion(questions[0]);
    }
}, [questions,checkQuestion]);

  const sendVideoBlobToBackend = async (blob,firstQuestion) => {
    let videourl
    let storedValue = localStorage.getItem("1stCodeQuestion");
if (storedValue) {
    let parsedValue = JSON.parse(storedValue);
    console.log("parsedValue", parsedValue);
    if (firstQuestion === undefined || firstQuestion === null) {
      // setCheckQuestion(true);
      console.log('firstindex:1', firstQuestion);
      videourl = parsedValue;
  } else {
      videourl = questions[currentQuestionIndex + 1];
  }
} else {
    console.log("No value found for key '1stQuestion' in localStorage.");
}
    // if(firstQuestion === undefined || firstQuestion === null){
    //   setCheckQuestion(true);
    //   console.log('firstindex:1', firstQuestion);
    //   videourl = questions[currentQuestionIndex + 1]

    // }else{
    //   console.log('firstindex:0', firstQuestion);
    //   videourl = questions[currentQuestionIndex + 1]
    // }
    console.log("current video url", videourl)
    // return
    // const videoBloburl = https://ai-recruiter.s3.amazonaws.com/videos/t_id_2024031919113352555302/1?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIA6N2VA2PSQGKMPCGP%2F20240319%2Fus-east-2%2Fs3%2Faws4_request&X-Amz-Date=20240319T113425Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEOT%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCXVzLWVhc3QtMiJGMEQCICZGYl42IEbo9uCFObopj7Nw0S51%2FZnllvBe%2BJh1WiZ0AiA3p8g%2FrgYKC%2BflzcttXShBjGeFKwroBuLv2lVc4DPwOyqUAwjt%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAEaDDk5MTc3ODg4NjYyOSIM%2BqqmB0TjFe3UNRuqKugC2jEgjZcK0NO0H6QikvPN1FcdsuVby4cFBy0nP2GUgNEn4IMHB1aCyaXy%2FfvlAIwhSOWhjXlzL1e7qLPQHiUFrChqK%2FIldmeGTBdsgxY49QyX8HskQUhsJeiiLk21e1c0zRutQGHrPV7pDFL1ppbLFeD%2F1DnoCky2sQnrcwhW9HmYllUe1qzuQ90p8Piq7SDZAutwJ1ca31J2F6NvbDzDMH%2BLKtLxy8Ik%2BWE0iDLyRaPWNB9RwDHxQDe%2Bb8%2BP5FwNKfO2x66F52mSc0d7VfqVoVKWaRFrlHOmlJeK6D59JViCpdTcG4M3Lxh03%2FLr7FQxZ9e8ZOOpjQHuH7sZ%2F%2BtPVqMzvfOTKddl2Z2po6gxjuaGWiWYKc1gTWvlz1yJFcMtKTTKgNBsl%2FLVeIiXlg4D3Tawe8qi2yhTgeB1H6cVOunIOgKC0xRKpaacSF%2Byy7K09Wm1gG5UzwUCO2l8YaNfiwMRmAXoKjU2MLzw5a8GOp4BpbgM6lXECnX8yRme%2BjXfI4GwM73O9tOb4zDmaI4sTom1RhlKdFlWIQhmqS%2BHva%2FGxMgUelzW039DNQxM1IFhscBIG465b1f8UHgyazeeq6vg3x2SzLt3BBNWQ%2FWma9c%2FH14A1TiyTA93PxTPulBxouHF5MDpVNqTFrIV6HADduN%2F554kP2XLjvhu4JoV5iUgDz4obQOHv7JjXLxNauw%3D&X-Amz-Signature=71232875176139de41557232d55a0cbcebb37276b80b3c8c42351d354024d10b
    try {
        console.log("video url's", videourl)
        // if (videourl) {
          const fields = videourl.video_url.fields;
          console.log("fields", fields)
          const url = videourl.video_url.url;
          const formData = new FormData();
          
            formData.append('key', fields.key);
            formData.append('x-amz-security-token', fields['x-amz-security-token']);
            formData.append('x-amz-signature', fields['x-amz-signature']);
            formData.append('policy', fields.policy);
            formData.append('x-amz-algorithm', fields['x-amz-algorithm']);
            formData.append('x-amz-date', fields['x-amz-date']);
            formData.append('x-amz-credential', fields['x-amz-credential']);
            formData.append('file', blob);
        
            console.log(formData);

            const presignedResp = await fetch(url, {
                method: 'POST',
                body: formData,
                headers: {
                    // 'Content-Type': 'multipart/form-data',
                },
            });

            if (presignedResp.status === 204) {
                // setSucMsg("File Uploaded Successfully");
                // setLoading(false);
                // Remove the URL from the array if upload is successful
                // setUrls(prevUrls => prevUrls.filter(u => u !== videourl));
            } else {
                // setLoading(false);
                // console.log("Presigned URL request failed:", presignedResp.status);
            }
        // }
    } catch (error) {
        // setLoading(false);
        // setSuccess("Failed To Upload File");
        console.error('Error:', error);
    }
};

  useEffect(() => {
    if (fetchedTestTimeId !== null) {
      setTimer(fetchedTestTimeId); 
      // if(localStorage.getItem("codetime")){
      //   const codeTime = localStorage.getItem("codetime")
      //   setTimer(codeTime); 
      // }else{
      //   setTimer(fetchedTestTimeId); 
      // }
    }
  }, [fetchedTestTimeId]);

  useEffect(() => {
    fetchQuestions();
  }, []);

  const fetchQuestions = async () => {
    try {
      setLoading(true);
      const payload = {"test_id": testId,}
      postDataUser('candidate/get-questions', payload).then(resp => {
        resp.json().then(respData => {
          if (resp.status === 200) {
            if (respData.statusCode === 200) {
              if (respData.message.toLowerCase() === 'success') {
                if (respData.dataJ.questions.length > 0) {
                   testTime = parseInt(respData.dataJ.coding_q_time);
                  setFetchedTestTimeId(testTime);
                  setLoading(false);
                  setError('')
                  setQuestions(respData.dataJ.questions);
                  setTotalQuestions(respData.dataJ.questions.length);
                  setFirstQuestion(respData.dataJ.questions[0]);
                  localStorage.setItem("1stCodeQuestion", JSON.stringify(respData.dataJ.questions[0]));
                } else {
                  if (respData.refresh_status === 0) {
                      setTimeout(() => {
                        fetchQuestions();
                      }, 30000);
                      setError("Questions Loading... Thanks for your patience!");
                  }else{
                    setError(respData.info);
                  }
                }
              } else {
                setError(respData.info);
                setLoading(false);
              }
            } else if(respData.statusCode === 500){
              setError(respData.info)
              setLoading(false);
            }else{
              setLoading(false);
              setError('Network Error');
            }
          } else if (resp.status === 401 || resp.status === 403) {
            console.log('resp status else if : ', resp.status);
            if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
              || respData.message === 'Access Denied') {
                setLoading(false);
              //   callRefreshTokenApi('getSfeBatch', '');
            }
          }else {
            console.log('resp status else  : ', resp);
            setLoading(false);
          }
        }).catch((error) => {
          setError('Network Error');
          console.log('network error:', error);
          setLoading(false);
        });
      }).catch((error) => {
        setError('Network Error');
        console.log('network error:', error);
        setLoading(false);
      });


    } catch (error) {
      console.error('Error fetching questions:', error);
      setLoading(false);
    }

  };

  useEffect(() => {
    let timerId;
  
    if (isTimerRunning && timer > 0) {
      timerId = setTimeout(() => {
        const minutes = Math.floor(timer / 60);
        const seconds = timer % 60;
        setTimer((prevTimer) => prevTimer - 1);
  
      }, 1000);
    } else if (timer <= 0) {
        if (timer !=null) {
        console.log('timer:',timer)
         
          handleNextQuestion();
        } else {
            console.log('else timer:',timer)
        }
        console.log('timer <= 0');
    } else {
      console.log('not 0');
    }
  
    return () => clearTimeout(timerId);
  }, [timer, isTimerRunning]);
  



  const handleNextQuestion = async () => {
    stopCapture();
    startCapture();
    // handleCodeChange();  
      try {
        const payload = {
            "test_id": testId,
            "qid": currentQuestion.qid,
            "q_answer": userCode,
            "end_button": currentQuestionIndex === totalQuestions - 1 || timer <= 0 ? 1:0
          }
        console.log('payload',payload)
        // return
        setLoading(true);
        await postDataUser('candidate/submit-coding-answers', payload).then(resp => {
          setLoading(false);
          resp.json().then(respData => {
            if (resp.status === 200) {
              if (respData.statusCode === 200) {
                if (respData.message.toLowerCase() === 'success') {
                    if(currentQuestionIndex === totalQuestions - 1 || timer <= 0){
                        navigate(`/users-summary?id=${payload.test_id}`);
                        setCurrentQuestionIndex(0);
                        setIsTimerRunning(false);
                        // localStorage.removeItem('codetime');
                    }else{
                        setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
                        // localStorage.setItem("codetime", timer);
                    }

                } else {
                  setRespError(resp.info);
                  console.log('resp else s : ', resp.info);
                }
              } else if(respData.statusCode === 500){
                setRespError(resp.info);
                console.log('resp else  : ', resp.info);
              }else{
                setRespError('Network Error');
              }
            } else if (resp.status === 401 || resp.status === 403) {
              console.log('resp status else if : ', resp.status);
              if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
                || respData.message === 'Access Denied') {
                //   callRefreshTokenApi('getSfeBatch', '');
                setRespError(resp.message);
              }
            }else {
              setRespError(resp.info);
              console.log('resp status else  : ', resp);
            }
          }).catch((error) => {
            setLoading(false);
            setRespError(error);
            console.log('network error:', error);
          });
        }).catch((error) => {
          setLoading(false);
          setRespError(error);
          console.log('network error:', error);
        });


      } catch (error) {
        setLoading(false);
        console.error('Error submitting answers:', error);
      }


  };

  const currentQuestion = questions[currentQuestionIndex];
  const [userCode, setUserCode] = useState(currentQuestion?.q_answer || currentQuestion?.skeleton_code || '');
  useEffect(()=>{
    setUserCode(currentQuestion?.q_answer || currentQuestion?.skeleton_code || '')
  },[currentQuestion] )
  
  const headerStyle = {
    backgroundColor: '#edf2fb',
    padding: '2px',
    display: 'flex',  // Use flexbox for layout
    alignItems: 'center',  // Align items vertically in the center
    justifyContent: 'space-between',  // Add space between items
};

  return (
    <div className='user-code-qus-div'>
    <UserNav />
    <div style={{display:'flex',justifyContent:'end', alignItems:"end",marginTop:'5px'}}>
      <video ref={videoRef} width="180" height="150" />
      </div>
    <div style={{padding:'40px 10px'}} >
      <div className="code-question-div">
        <Row className="justify-content-center">
          <Col xs={12} md={12}>
            {questions.length !== 0 ? (
              <div> 
                    <div className="mt-3 text-end time-div-2">                    
                    <p className='timer-p' style={{ color: timer <= 30 ? 'red' : ''}}>
                    Time Remaining: {Math.floor(timer / 60)}:{(timer % 60).toString().padStart(2, '0')} minutes
                    </p>

                </div>               
                    <div className='display-qns-div'>
                        <div className='col-md-6 col-12' style={{ borderRight: '1px solid #8080803d',padding:'8px' }}>
                            <h5 style={{color:'#0073b1'}}> {currentQuestion?.qid}.Question</h5>
                            <p style={{paddingLeft:'8px'}}>{currentQuestion?.task}</p>
                            {/* {currentQuestion?.skeleton_code && <>
                                <h6 style={{color:'#0073b1'}}>INPUT</h6>
                                <pre className='box-border-sty' style={{ whiteSpace: 'pre-wrap',paddingLeft:50 }}>
                            <code>{currentQuestion?.skeleton_code}</code>
                          </pre></>
                            } */}
                            {currentQuestion?.sample_output && <><h6 style={{color:'#0073b1'}}>OUTPUT</h6>
                            <pre className='box-border-sty' style={{ whiteSpace: 'pre-wrap',paddingLeft:50 }}>
                            <code>{currentQuestion?.sample_output}</code>
                          </pre></>}

                          {currentQuestion?.q_tech === 'SQL' ? <>
                          {currentQuestion?.scenario?.length > 0 ? (<>
                            <h6 style={{color:'#0073b1'}}>Test Cases</h6>
                            <div>
                            {currentQuestion?.scenario.map((testCase, index) => (
                                  <div key={index}>
                                      <h6 style={{color:'#5d05f7'}}>{testCase.table_name}</h6>
                                      <pre>
                                      <span style={{color:'#5d05f7'}}>Structure: </span> 
                                           {testCase.structure}
                                      </pre>
                                         <span style={{color:'#5d05f7'}}>Sample Data: </span> 
                                      <pre className='box-border-sty'>
                                          {testCase.sample_data.split('\n').map((line, i) => (
                                              <div key={i}>{line}</div>
                                          ))}
                                      </pre>
                                  </div>
                              ))}
                            </div>
                          

                          </>):(<>
                            {JSON.stringify(currentQuestion?.scenario) && <>
                            <h6 style={{color:'#0073b1'}}>Test Cases</h6>
                            <p className='' style={{paddingLeft:'8px'}}> {JSON.stringify(currentQuestion?.scenario)}
                            </p> </>}                          
                          </>)}

                          </>:<>
                          {JSON.stringify(currentQuestion?.scenario) && <>
                            <h6 style={{color:'#0073b1'}}>Test Cases</h6>
                            <p className='' style={{paddingLeft:'8px'}}> {JSON.stringify(currentQuestion?.scenario)}
                            </p> </>}
                          </>}

                 
                            <></>

                        </div>
                        
                            <div className='col-md-6 col-12'>
                            <Form noValidate >
                                <div className='d-flex'>
                                    <div className="text-center flex-grow-1" style={{ marginRight: '20px' }}>
                                        <Form.Group as={Col} xs={12} style={{ marginBottom: '10px', marginLeft: '15px', marginRight: '50px' }}>
                                        <Form.Control
                                            as="textarea"
                                            rows={17}
                                            onChange={(e) => setUserCode(e.target.value)}
                                            value={userCode}
                                            placeholder="Write Code Here"
                                            disabled={timer === 0}
                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                              </Form>
                              <div className="text-center mt-3">
                                <Button variant="dark" onClick={handleNextQuestion} >
                                {currentQuestionIndex + 1}/{questions.length} {currentQuestionIndex === totalQuestions - 1 ? 'Submit':'Next Question'}
                                    </Button>
                                </div>

                            </div>
                        

                    </div>

           
                {/* <div className="text-center mt-3 timet-div">
                    <div>
                    <img src={clock} alt="clock" width={60} height={80} />
                    </div>
                    <p style={{ color: timer <= 30 ? 'red' : '', margin: 0 }}>
                    Time Remaining: {Math.floor(timer / 60)}:{(timer % 60).toString().padStart(2, '0')} minutes
                    </p>

                </div> */}
          
                {loading && (
                  <div className="spinner-overlay">
                    <Spinner animation="border" role="status">
                      <span className="sr-only"></span>
                    </Spinner>
                  </div>
                )}
                <div>
                  {respError && <p className='error-msg'>{respError}</p>}
                </div>
              </div>
            ) : (
              <>
              <div>
                {error && <p className='error-qns-msg'>{error}</p>}
              </div>
              <div>
                {loading && (
                      <div className="spinner-overlay-qna">
                        <Spinner animation="border" role="status">
                          <span className="sr-only"></span>
                        </Spinner>
                      </div>
                    )}
            </div>
              </>
              
            ) 
            }
            
          </Col>
        </Row>
      </div>
    </div>
    <footer className='footer-div'>
      <p style={{color:'white'}}>&copy; 2024 Data Lake Solutions LLC. All rights reserved.</p>
      </footer>
    </div>

  );
};

export default CodeInterviewPage;

    